import { render, staticRenderFns } from "./unknownUser.vue?vue&type=template&id=4502612d&"
import script from "./unknownUser.vue?vue&type=script&lang=js&"
export * from "./unknownUser.vue?vue&type=script&lang=js&"
import style0 from "./unknownUser.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports